const bulb = require("../images/Electrical Symbols/bulb.png");
const ammeter = require("../images/Electrical Symbols/ammeter.png");
const cell_group = require("../images/Electrical Symbols/cellgrp.png");
const cell = require("../images/Electrical Symbols/cell.png");
const voltmeter = require("../images/Electrical Symbols/voltmeter.png");
const LDR = require("../images/Electrical Symbols/LDR.png");
const thermistor = require("../images/Electrical Symbols/thermistor.png");
const resistor = require("../images/Electrical Symbols/resistor.png");
const variable_resistor = require("../images/Electrical Symbols/variable resistor.png");
const fuse = require("../images/Electrical Symbols/fuse.png");
const LED = require("../images/Electrical Symbols/LED.png");
const motor = require("../images/Electrical Symbols/motor.png");
const heater = require("../images/Electrical Symbols/motor.png");
const transformer = require("../images/Electrical Symbols/transformer.png");

module.exports = {
    bulb: bulb,
    ammeter: ammeter,
    cell_group: cell_group,
    cell: cell,
    voltmeter: voltmeter,
    LDR: LDR,
    thermistor: thermistor,
    resistor: resistor,
    variable_resistor: variable_resistor,
    fuse: fuse,
    LED: LED,
    motor: motor,
    transformer: transformer,
};
